import React from 'react';
import { Helmet } from 'react-helmet';

import Section from 'app/components/common/Section';
import PairsTable from 'app/components/tables/PairsTable';
import { useGetPairsLazyQuery } from 'app/generated/graphql';

import s from './Pairs.module.sass';

const Pairs: React.FC = () => {
  const [fetch, { data }] = useGetPairsLazyQuery();

  return (
    <>
      <Helmet>
        <title>QuipuSwap Statistic - Trading pairs list</title>
        <meta
          name="description"
          content="Get detailed information about trading pairs on QuipuSwap DEX:
          volume, transactions, prices, liquidity, etc."
        />
      </Helmet>

      <div className={s.root}>
        <Section head title="Pairs">
          <PairsTable
            pageSize={50}
            fetch={fetch}
            data={data}
          />
        </Section>
      </div>
    </>
  );
};

export default Pairs;
